import { string } from 'prop-types'
import { Field } from '@groovehq/internal-design-system/lib/components'
import { styles } from './styles'
import AddTag from '../../AddTag'

const AdditionalInfo = ({ className }) => {
  const orderTags = []
  const existedTags = []
  return (
    <div className={className} css={styles.base}>
      <Field label="Notes" placeholder="Add a note…" className="grui mb-11" />
      <AddTag orderTags={orderTags} existedTags={existedTags} />
    </div>
  )
}

AdditionalInfo.propTypes = {
  className: string,
}

AdditionalInfo.defaultProps = {
  className: undefined,
}

export default AdditionalInfo
